import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useAuth} from '../../../../modules/auth'
import {addDoc, collection, doc, onSnapshot} from 'firebase/firestore'
import db from '../../../../../services/firebase'
import {ToastContainer} from 'react-toastify'
import {createTask} from 'app/Integrations/Linear'

interface ViewTaskProps {
  control_id?: string
  test_id?: string
  isOpen: boolean
  onClose: () => void
}

type Assigne = {
  id: string
  email: string
  group: string
  full_name: string
  uid: string
}

const AddTask: React.FC<ViewTaskProps> = ({isOpen, onClose, test_id, control_id}) => {
  const [owners, setOwners] = useState<any[]>([])
  const {currentUser} = useAuth()
  const [owner, setOwner] = useState<Assigne | null>(null)
  const [taskName, setTaskName] = useState('')
  const [priority, setPriority] = useState('')
  const [dueDate, setDueDate] = useState('')
  const [sendEmail, setSendEmail] = useState(false)
  const [controlTask, setControlTask] = useState('')
  const [testTask, setTestTask] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [Tests, setTests] = useState([] as any[])
  const [description, setDescription] = useState('')
  const [integration, setIntegration] = useState<any[]>([])
  const [selectedOwnerEmail, setSelectedOwnerEmail] = useState('')
  const [sendLinearMessage, setSendLinearMessage] = useState(false)
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})

  useEffect(() => {
    getTests()
  }, [test_id])

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'employees')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const risksData = snapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          end_date: doc.data().end_date,
        }))
        .filter((data) => !data.end_date)
      setOwners(risksData)
    })

    return unsubscribe
  }, [])

  useEffect(() => {
    getIntegration()
  }, [])

  const getIntegration = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'integrations')

      // const limitedQuery = query(controlsCollectionRef, limit(10))

      const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
        const integrationData = snapshot.docs
          .map((item) => ({
            ...item.data(),
            id: item.id,
            name: item.data().name,
          }))
          .filter((item) => item.name === 'Linear')
        setIntegration(integrationData)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting controls:', error)
    }
  }

  const getTests = async () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)

      const testsCollectionRef = collection(tenantRef, 'tests')
      if (!test_id) {
        return
      }
      const testDocRef = doc(testsCollectionRef, test_id)

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const testsData = snapshot.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
            policies: doc.data().policies,
            policyId: doc.data().policyId,
            name: doc.data().name,
          }))
          .filter((test) => test.id === test_id)
        setTests(testsData)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting controls:', error)
    }
  }

  const handleCheckedEmail = () => {
    setSendEmail(!sendEmail)
  }

  const validateForm = () => {
    const errors: Record<string, string> = {}

    if (!taskName.trim()) {
      errors.taskName = 'Task Name is required'
    }

    if (!priority.trim()) {
      errors.priority = 'Task priority is required'
    }

    if (!owner) {
      errors.owner = 'Task Owner is required'
    }

    if (!dueDate.trim()) {
      errors.dueDate = 'Task DueDate is required'
    }

    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth() + 1
    const day = currentDate.getDate()
    const todaysDate = `${month}/${day}/${year}`

    if (currentUser) {
      const tenantRef = doc(db, 'tenants', currentUser.tenantId!)
      const activitiesRef = collection(tenantRef, 'tasklists')

      try {
        setIsLoading(true)

        await addDoc(activitiesRef, {
          task_name: taskName,
          description: description,
          priority: priority,
          owner: owner?.full_name,
          assignee_id: owner?.uid,
          duedate: dueDate || '',
          control: controlTask || '',
          test: testTask || '',
          tenantId: currentUser?.tenantId,
          username: currentUser?.userName,
          date: todaysDate,
          checked: false,
          test_id: test_id ?? '',
          deliverable: {
            email: sendEmail,
            Linear: sendLinearMessage,
          },
          status: 'Incomplete',
          control_id: control_id ?? '',
        })

        if (integration[0].status === 'Connected') {
          const access_token = integration.length > 0 ? integration[0].access_token : ''
          const teamName = integration.length > 0 ? integration[0].teamName : ''

          createTask(
            access_token,
            teamName,
            taskName,
            description,
            priority,
            dueDate,
            selectedOwnerEmail
          )
            .then((task) => console.log(task))
            .catch((error) => console.error(error))
        }
        setTaskName('')
        setPriority('')
        setDueDate('')
        setSendEmail(false)
        setOwner(null)
        setControlTask('')
        setTestTask('')
        setDescription('')
        setSendEmail(false)
        setSendLinearMessage(false)
      } catch (error) {
        console.error('Error adding document: ', error)
      } finally {
        setIsLoading(false)
        onClose()
      }
    }
  }

  const onCancel = () => {
    setFormErrors({})
    onClose()
  }

  return (
    <Modal show={isOpen} onHide={onCancel} backdropClassName='bg-opacity-1' centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Task</Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-0 mt-4'>
        <form className='px-6' onSubmit={handleSubmit}>
          <div className='fv-row'>
            <label className=' fw-bold fs-7 mb-1' style={{color: '#5A5A5A'}}>
              Test
            </label>
            <p className='fs-6 fw-semibold'>
              {Tests.length > 0 && Tests[0].name ? Tests[0].name : ''}
            </p>
          </div>
          <div className='separator my-4'></div>
          <div className='fv-row mb-4 '>
            <label className=' fw-semibold fs-6 mb-1 required'>Task Name</label>
            <input
              placeholder='Enter Task Name'
              type='text'
              className={`form-control ${formErrors.taskName ? 'is-invalid' : ''}`}
              name='taskname'
              value={taskName}
              onChange={(e) => setTaskName(e.target.value)}
              autoComplete='off'
            />
            {formErrors.taskName && <div className='invalid-feedback'>{formErrors.taskName}</div>}
          </div>

          <div className='fv-row mb-4'>
            <label className='fw-bold fs-6 mb-2'>Description</label>
            <textarea
              placeholder='Enter description for task'
              className='form-control mb-3 mb-lg-0 w-100'
              name='description'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              autoComplete='off'
            />
          </div>

          <div className='fv-row mb-4 '>
            <label className=' fw-semibold fs-6 mb-1 required'>Priority</label>
            <select
              className={`form-select  ${formErrors.priority ? 'is-invalid' : ''}`}
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
            >
              <option selected>Select Priority</option>
              <option value='Low'>Low</option>
              <option value='Medium'>Medium</option>
              <option value='High'>High</option>
            </select>
            {formErrors.priority && <span className='invalid-feedback'>{formErrors.priority}</span>}
          </div>
          {/* <div className='fv-row  '>
            <label className=' fw-semibold fs-6 mb-1'>Assign to</label>
            <select
              data-placeholder='Select Owner'
              onChange={(e) => {
                const selectedOwner = owners.find((owner) => owner.id === e.target.value) || null
                setOwner(selectedOwner)
              }}
              value={owner?.id || ''}
              className='form-select  mb-3 mb-lg-0 w-100'
            >
              <option selected>Select Owner</option>
              {owners
                .filter((user) => user.role === 'Admin' || user.role === 'Owner')
                .map((owner) => (
                  <option key={owner.id} value={owner.id}>
                    {owner.full_name}
                  </option>
                ))}
            </select>
          </div> */}
          <div className='fv-row'>
            <label className=' fw-semibold fs-6 mb-1 required'>Assign to</label>
            <select
              data-placeholder='Select Owner'
              onChange={(e) => {
                const [selectedFullName, selectedEmail] = e.target.value.split('|')
                const selectedOwner =
                  owners.find(
                    (owner) => owner.full_name === selectedFullName && owner.email === selectedEmail
                  ) || null
                setOwner(selectedOwner)
                setSelectedOwnerEmail(selectedEmail)
                // setFormErrors((prev) => ({...prev, owner: ''}))
              }}
              value={`${owner}|${selectedOwnerEmail}`}
              className={`form-select  ${formErrors.owner ? 'is-invalid' : ''}`}
            >
              <option value='' selected>
                Select Owner
              </option>
              {owners
                .filter((user) => user.role === 'Admin' || user.role === 'Owner')
                .map((owner) => (
                  <option key={owner.id} value={`${owner.full_name}|${owner.email}`}>
                    {owner.full_name}
                  </option>
                ))}
            </select>
            {formErrors.owner && <span className='invalid-feedback'>{formErrors.owner}</span>}
          </div>
          <div className='form-group mb-4'>
            <label className='fw-semibold mt-5 fs-6 mb-1 required'>Due date</label>
            <input
              type='date'
              className={`form-control ${formErrors.dueDate ? 'is-invalid ' : ''}`}
              placeholder='Selcted due date'
              name='dateOfLastReview'
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
            />
            {formErrors.dueDate && <span className='invalid-feedback'>{formErrors.dueDate}</span>}
          </div>
          {/* <div className='fv-row p-0 my-0 '>
            <label className=' fw-semibold mt-5 fs-6 mb-1'>Delivery</label>
            <div style={{textAlign: 'center', display: 'flex', marginTop: '4px'}}>
              <div className='form-check form-check-sm form-check-custom form-check-solid'>
                <input
                  className='form-check-input widget-9-check'
                  type='checkbox'
                  checked={sendEmal}
                  onChange={() => handleCheckedEmail()}
                />
              </div>
              <div className='text-dark fs-6' style={{marginLeft: '6px'}}>
                Email
              </div>
            </div>
          </div> */}
          <div className='form-group '>
            <label className='fw-semibold text-dark fs-6 mb-4'>Delivery</label>
            <div className='checkbox-group '>
              <div className='form-check mb-4'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='sendEmailCheckbox'
                  checked={sendEmail}
                  onChange={(e) => setSendEmail(e.target.checked)}
                />
                <label className='text-dark ms-2 fs-6' htmlFor='sendEmailCheckbox'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#5A5A5A'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-mail me-1 mb-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z' />
                    <path d='M3 7l9 6l9 -6' />
                  </svg>{' '}
                  Send email
                </label>
              </div>
              {currentUser?.account_type !== 'Trial' && currentUser?.account_type === 'internal' && (
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id='sendLinearMessageCheckbox'
                    checked={sendLinearMessage}
                    onChange={(e) => {
                      setSendLinearMessage(e.target.checked)
                    }}
                    disabled={integration.length === 0 || integration[0].status !== 'Connected'}
                  />
                  <label className='text-dark ms-2 fs-6' htmlFor='sendLinearMessageCheckbox'>
                    <img
                      src='/media/icon/Linear_Symbol_1.png'
                      width={18}
                      className='me-1 mb-1'
                      alt=''
                    />{' '}
                    Create issue on Linear{' '}
                    {integration.length > 0 && integration[0].teamName ? (
                      <span
                        className='badge fs-7'
                        style={{
                          color: integration[0].status === 'Connected' ? '#0E9F6E' : '#FF0000',
                          background: integration[0].status === 'Connected' ? '#E8F8F4' : '#FFCCCC',
                        }}
                      >
                        {integration[0].status}
                      </span>
                    ) : integration[0] && !integration[0].teamName ? (
                      <span
                        className='badge fs-7 badge-warning'
                        style={{cursor: 'pointer'}}
                        onClick={() =>
                          (window.location.href = `/integrations?id=${integration[0].id}&service=Linear`)
                        }
                      >
                        Select a team
                      </span>
                    ) : (
                      <span
                        className='badge fs-7 badge-secondary'
                        style={{cursor: 'pointer'}}
                        onClick={() =>
                          (window.location.href = '/integrations/available?service=Linear')
                        }
                      >
                        Connect integration
                      </span>
                    )}
                  </label>
                </div>
              )}
            </div>
          </div>
          <div className='modal-footer  p-0 my-4 pt-4'>
            <button
              className='btn btn-sm btn-light mx-2 fs-6'
              onClick={onCancel}
              style={{
                height: '40px',
                borderRadius: '4px',
                transition: 'background-color 0.3s',
              }}
            >
              Cancel
            </button>
            {isLoading ? (
              <button
                className='btn btn-sm fs-6'
                type='submit'
                onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                  (e.currentTarget.style.backgroundColor = '#148363')
                }
                onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                  (e.currentTarget.style.backgroundColor = '#0E9F6E')
                }
                // disabled={activities.length === 0}
                style={{
                  backgroundColor: '#0E9F6E',
                  color: '#fff',
                  height: '40px',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s',
                }}
              >
                Adding Task...
                <span className='spinner-border spinner-border-sm align-middle'></span>
              </button>
            ) : (
              <button
                className='btn btn-sm fs-6'
                type='submit'
                onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                  (e.currentTarget.style.backgroundColor = '#148363')
                }
                onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                  (e.currentTarget.style.backgroundColor = '#0E9F6E')
                }
                onClick={handleSubmit}
                style={{
                  backgroundColor: '#0E9F6E',
                  color: '#fff',
                  height: '40px',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s',
                }}
              >
                Add Task
              </button>
            )}
          </div>
        </form>
      </Modal.Body>
      <ToastContainer />
    </Modal>
  )
}

export default AddTask
